import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-tarjeta-producto',
    templateUrl: './tarjeta-producto.component.html',
    styleUrls: ['./tarjeta-producto.component.css']
})
export class TarjetaProductoComponent implements OnInit {

	@Input() newProducto:any = {};
    identificador:string = "";

    constructor( private newRouter:Router ) { }

    ngOnInit(): void {
        this.identificador = encodeURI(`${this.newProducto["skuProveedor"]} ${this.newProducto["alias"]}`);
    }

    fnGetImage(){
        if( this.newProducto ){
            return this.newProducto.fotografia;
        }else{
            return "";
        }
    }

    fnInformacionProducto(){

    }

}
